module.exports = __webpack_public_path__ + "static/a2-2b84036461c3cb7eeb98813efab9cd46.jpg";